export default __webpack_public_path__ + "assets/b65cd951b48ccc604c9888d2c30d73dd.svg";